import { render, staticRenderFns } from "./turnos.vue?vue&type=template&id=1e3040b0"
import script from "./turnos.vue?vue&type=script&lang=js"
export * from "./turnos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports